/* global Intl */
import React, { useState, useMemo } from 'react';
import { useData } from '../../context/DataContext';
import SafeIcon from '../../common/SafeIcon';
import ResultCard from './ResultCard';
import * as FiIcons from 'react-icons/fi';

const { FiPackage } = FiIcons;

const ResultsList = ({ results }) => {
  const { incidents } = useData();
  const [expandedItems, setExpandedItems] = useState(new Set());
  const [showAllResults, setShowAllResults] = useState(false);

  const INITIAL_RESULTS_COUNT = 10;

  const sortedResults = useMemo(() => {
    return [...results].sort((a, b) => {
      const wA = a.wardrobeOrder ?? 9999;
      const wB = b.wardrobeOrder ?? 9999;
      if (wA !== wB) return wA - wB;
      
      return new Intl.Collator(undefined, { numeric: true, sensitivity: 'base' })
        .compare(String(a.locker || ''), String(b.locker || ''));
    });
  }, [results]);

  const visibleResults = showAllResults ? sortedResults : sortedResults.slice(0, INITIAL_RESULTS_COUNT);
  const hasMoreResults = results.length > INITIAL_RESULTS_COUNT && !showAllResults;

  const toggleExpanded = (itemId) => {
    const newExpanded = new Set(expandedItems);
    if (newExpanded.has(itemId)) newExpanded.delete(itemId);
    else newExpanded.add(itemId);
    setExpandedItems(newExpanded);
  };

  if (results.length === 0) {
    return (
      <div className="text-center py-8">
        <SafeIcon icon={FiPackage} className="text-4xl text-gray-300 mx-auto mb-4" />
        <p className="text-gray-500">No se encontraron resultados</p>
      </div>
    );
  }

  return (
    <div className="space-y-3 pb-20">
      {visibleResults.map((item, index) => (
        <ResultCard 
          key={item.id}
          item={item}
          index={index}
          isExpanded={expandedItems.has(item.id)}
          onToggle={() => toggleExpanded(item.id)}
          incidentCount={incidents.filter(inc => 
            item.garments?.some(g => g.barcode === inc.barcode) || inc.employeeCode === item.employeeCode
          ).length}
        />
      ))}

      {hasMoreResults && (
        <div className="text-center pt-6">
          <button 
            onClick={() => setShowAllResults(true)} 
            className="px-6 py-2 bg-white border border-red-200 text-red-600 rounded-full text-sm font-bold hover:bg-red-50 transition-colors shadow-sm"
          >
            Ver todos los resultados ({results.length})
          </button>
        </div>
      )}
    </div>
  );
};

export default ResultsList;